import { sanitizeUrl } from "./sentry";

type ResponseSource = Pick<Response, "status" | "url">;

const detailCodePattern = /^[A-Za-z0-9_.-]{1,64}$/;

// 本文には患者情報などが入りうるため、監視サービスへ送る detail には許可したキーを想定した形式のときだけ残す
const pickReportableBody = (json: unknown) => {
  if (typeof json !== "object" || json === null || Array.isArray(json)) return {};

  const { code, detail_code } = json as { code?: unknown; detail_code?: unknown };
  return {
    code: typeof code === "number" ? code : undefined,
    detail_code: typeof detail_code === "string" && detailCodePattern.test(detail_code) ? detail_code : undefined,
  };
};

export const toStatusUrlMessage = ({ status, url }: ResponseSource) => `[${status}] ${sanitizeUrl(url)}`;

export const toApiErrorDetailMessage = ({ status, url }: ResponseSource, json: unknown) =>
  JSON.stringify({ url: sanitizeUrl(url), status, body: pickReportableBody(json) });

export const responseToErrorMessage = async (response: Response) => {
  try {
    const json: unknown = await response.json();
    return toApiErrorDetailMessage(response, json);
  } catch (_e) {
    return toStatusUrlMessage(response);
  }
};
